module.exports = __webpack_public_path__ + "media/images/athletes/3432-83b3be5a810c3f0210c27fbe75cc1eb5.png";